import { classNames } from "@opensea/ui-kit"

export const RECEIPT_TABLE_COLUMN_CLASSNAMES = {
  item: classNames("grow first:pl-0"),
  price: classNames("justify-end"),
}
